import { FC } from 'react';
import analytics from '@analytics/index';
import { profile } from '../services/profile';

const FullCvLink: FC<{ className?: string }> = ({ className }) => (
    <a className={className} href={profile.cvPath} onClick={() => analytics.trackLink(profile.cvPath, 'cv')}>
        Full CV
    </a>
);

export default FullCvLink;
